// @flow
import _ from 'lodash';
import * as React from 'react';
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import styled from 'styled-components';
import type { TPlayerWithFixture } from '../../modules/types/player';
import * as selectors from "../../modules/selectors";
import SidebarWidget from '../SidebarWidget';
import PeopleIcon from '../Icons/People';
import * as actions from '../../modules/actions';
import colors from '../../assets/css/colors';
import { getSquadSize } from '../../helpers/league';
import { Tooltip } from "../../components";
import RoundDevider from './RoundDevider';

const size = '24px';

const RoundContent = styled.div`
	max-height: 310px;
	overflow-y: auto;
	background:
		linear-gradient(white 30%, rgba(255,255,255,0)),
		linear-gradient(rgba(255,255,255,0), white 70%) 0 100%,
		radial-gradient(farthest-side at 50% 0, rgba(0,0,0,.2), rgba(0,0,0,0)),
		radial-gradient(farthest-side at 50% 100%, rgba(0,0,0,.2), rgba(0,0,0,0)) 0 100%;
	background-repeat: no-repeat;
	background-color: white;
	background-size: 100% 40px, 100% 40px, 100% 14px, 100% 14px;
	background-attachment: local, local, scroll, scroll;

	ul {
			  max-width: 350px;
			  //counter-reset: list1;
			  list-style: none;
			  padding-left: 40px;

		 li {
			  margin: 0 0 2em 0;
			  //counter-increment: list1;
			  font-size: 12px;
			  position: relative;
			  font-weight: bold;
			  color: ${colors.nrlDarkGreen};

			  > p {
				font-weight: normal;
				color: ${colors.darkGrey};
				margin-top: 0.3em;
			  }

			  &.picked {
				color: #C0C0C0;

				&::before {
					color: #777;
				}
			  }

			}

		 li::before {
			  content: attr(data-pick);
			  color:  ${colors.nrlDarkGreen};
			  font-weight: bold;
			  font-size: 12px;
			  position: absolute;
			  left: calc(-1 * ${size} - 14px);
			  line-height: ${size};
			  width: ${size};
			  height: ${size};
			  top: 0;
			  background: ${colors.lightGreen};
			  border-radius: 50%;
			  text-align: center;
			  box-shadow: none;
		}
	}
`;

type Props = {
	selected_league_id: number,
	showDraftOrder: typeof actions.leagueDraft.showDraftOrder,
	is_live?: boolean,
	icon: React.Element<any>,
	showDraftOrder: Function,
	onToggle: Function,
	fetchLeague: typeof actions.leagueDraft.showDraftLeague,
	widget_open: boolean,
	error?: string,
	league?: Object,
	teams: Array<Object>,
	match: {
		params: {
			league_id: string
		}
	},
	picked_players_by_pick?: { [key:string]: TPlayerWithFixture },
	players_by_id: Object,
	is_pending_players: boolean
}

class DraftOrderWidgetContainer extends React.Component<Props> {
	constructor(props, state) {
		super(props, state);

		_.bindAll(this, ['getRoundContent']);
	}

	componentDidMount() {
		this.fetchLeague();
		const { league_id } = this.props.match.params;
		this.props.showDraftOrder({ league_id });
	}

	fetchLeague() {
		const { fetchLeague, selected_league_id } = this.props;
		fetchLeague({
			id: selected_league_id
		});
	}

	getRoundContent(round_number) {
		const {
				teams, picked_players_by_pick,
				players_by_id, is_live
			} = this.props,
			// draft_order = _.get(league, 'draft_order', 'linear'),
			// is_snake = draft_order === 'snake',
			koef = round_number === 1 ? round_number : (round_number - 1) * teams.length + 1;
			// teams_to_show = round_number % 2 && is_snake ? teams : _.reverse(teams.slice());
		return (
			<div key={round_number}>
				<RoundDevider round_number={round_number}/>
				<ul>
					{/* {teams_to_show.map((team, index) => { */}
					{teams.map((team, index) => {
						const pick = koef + index;
						const picked_player = _.get(picked_players_by_pick, pick + 1, {});
						let player = _.get(players_by_id, picked_player.picked_player_id, false);

						const is_picked = is_live && player;
						return (
							<li
								key={team.id}
								data-pick={pick}
								className={is_picked ? 'picked' : ''}>
								{ is_picked ? (
									<React.Fragment>
										{player.first_name} {player.last_name}
										<p>Selected By {team.name}</p>
									</React.Fragment>
								) : (
									<React.Fragment>
										{team.name}
										<p>{team.firstname}</p>
									</React.Fragment>
								)}
							</li>
						);
					})}
				</ul>
			</div>
		);
	}

	get widget_content() {
		const { error } = this.props;

		if(error) {
			return <div>{error}</div>;
		}

		const { league } = this.props,
			teams = this.props.teams,
			is_live = this.props.is_live,
			total = is_live && league ? getSquadSize(league) : 1,
			rounds = _.range(1, total + 1),
			content = _.isEmpty(teams) ? null : (
				<div>{ _.map(rounds, this.getRoundContent) }</div>
			);

		return (
			<div>
				<RoundContent>
					{ content }
				</RoundContent>
			</div>
		);
	}

	render() {
		const TooltipComponent = (<Tooltip
			show_on_left={true}
			title={''}
			description={'Below displays the complete ' +
			'draft order, pick by pick the entire draft. ' +
			'Please refer to this to see where you will ' +
			'be drafting for each specific round'}
		/>);

		return (
			<SidebarWidget
				icon={<PeopleIcon/>}
				title="Draft Order"
				widget_open={this.props.widget_open}
				onToggle={this.props.onToggle}
				rightIcon={TooltipComponent}
			>
				{this.widget_content}
			</SidebarWidget>
		);
	}
}

const mapDispatchToProps = ({
	showDraftOrder: actions.leagueDraft.showDraftOrder,
	fetchLeague: actions.leagueDraft.showDraftLeague,
});

const mapStateToProps = (state, props) => {
	const { leagues: { show_order: { error }, teams_by_id } } = state;
	const selected_league_id = props.match.params.league_id;

	const teams = selectors.leagueDraft.getLeagueDraftOrder(state).map(
		team_id => teams_by_id[team_id]
	).filter(_.identity);

	return {
		selected_league_id,
		error,
		teams_by_id,
		league: selectors.leagueDraft.getLeague(state, props),
		teams,
		players_by_id: state.players.by_id,
		is_pending_players: state.players.is_pending,
	};
};

export const DraftOrderWidget = withRouter(connect(
	mapStateToProps,
	mapDispatchToProps,
)(DraftOrderWidgetContainer));

export default DraftOrderWidget;


// WEBPACK FOOTER //
// ./src/components/DraftOrderWidget/index.js